import { useNavigate, useLocation } from 'react-router-dom';
import { useCallback, useMemo } from 'react';

import { Else, If, Then } from 'react-if';
import PageHeader from '../../../shared/blocks/page-header/page-header';
import AddressForm from '../../../shared/forms/address-form';
import useAddresses from '../../../../utilities/hooks/useAddresses';
import useUpdateAddress from '../../../../utilities/hooks/useUpdateAddress';
import useSetPrimaryAddress from '../../../../utilities/hooks/useSetPrimaryAddress';
import Loader from '../../../shared/blocks/loader/loader';

const EditAddress = () => {
  const navigate = useNavigate();
  const addresses = useAddresses();
  const location = useLocation().search;
  const params = new URLSearchParams(location);
  const id = params.get('id');
  const address = useMemo(() => addresses?.find((a) => a.id === id), [addresses, id]);

  const { update: updateAddress, isLoading: isUpdatingAddress } = useUpdateAddress();
  const { set: setPrimaryAddress, isLoading: isSettingPrimaryAddress } = useSetPrimaryAddress();

  const handleBack = useCallback(() => {
    navigate('/addresses');
  }, [navigate]);

  const handleSubmit = useCallback((formValues) => {
    if (address) {
      const { isDefaultShippingAddress, ...payload } = formValues;
      updateAddress(address.id, { ...payload, email: address.email }, {
        onSuccess: () => {
          if (isDefaultShippingAddress) {
            setPrimaryAddress(address.id, {
              onSuccess: handleBack,
            });
          } else {
            handleBack();
          }
        },
      });
    }
  }, [address, handleBack, setPrimaryAddress, updateAddress]);

  return (
    <div className="edit-address-page">
      <PageHeader title="Edit address" />

      <If condition={address}>
        <Then>
          <AddressForm
            defaultValues={address}
            onCancel={handleBack}
            onSubmit={handleSubmit}
            submitting={isUpdatingAddress || isSettingPrimaryAddress}
          />
        </Then>
        <Else>
          <Loader />
        </Else>
      </If>

    </div>
  );
};

export default EditAddress;
